import { mapActions, mapState } from 'vuex';
  
  export default {
    data() {
      return {
        inputType: 'password' 
      };
    },
    
    created() {
      this.hideLoading();
    },
    computed: {
      ...mapState({
        loading(state) { return state.loading; }
      }),
      ...mapState('loginStore', {
        loginInfo(state) { return state.loginInfo; }
      }),

      isPassword() {
        return this.inputType === 'password';
      }
    },
    methods: {
      ...mapActions([
        'showLoading',
        'hideLoading'
      ]),
      ...mapActions('loginStore', [
        'validarAcesso',
      ]),

      setInputSenha() {
        this.inputType = this.isPassword ? 'text' : 'password'
      },

      logarHandler() {
        this.logar();
      },
      logar() {
        this.showLoading();
        this.validarAcesso(this.loginInfo)
        .then((resultado) => {
          switch(resultado.status) {
            case "SUCESSO":
              this.$router.push("/imobiliarias");
              break;
            default:
              this.$message.warning(resultado.mensagem);
          }
          this.hideLoading();
        }).catch(() => {
          this.hideLoading();
          this.$message.error('Não foi possível conectar-se ao servidor');          
        });
      }
    }
  }